const SCANNER_PATTERNS = [/^nessus_was_text/i];

export function isScannerQuery(query) {
  if (!query || typeof query !== 'string') return false;
  return SCANNER_PATTERNS.some((pattern) => pattern.test(query));
}

export function createFilteredQueryHook(debounceMs = 350, minLength = 2) {
  let debounceTimer = null;

  return function queryHook(query, search) {
    clearTimeout(debounceTimer);

    if (isScannerQuery(query)) {
      return;
    }

    if (query.length === 0 || query.length >= minLength) {
      debounceTimer = setTimeout(() => search(query), debounceMs);
    }
  };
}
